module.exports = __webpack_public_path__ + "img/phpExpressLogo.a4aafdf.webp";